// src/flows/guided-masterclass/ai/StepAI_Purpose.tsx
import { StepAI_Purpose as MasterclassStepAI_Purpose } from '../../masterclass/ai/StepAI_Purpose';

export function StepAI_Purpose() {
  return <MasterclassStepAI_Purpose model="masterclass&mentorship" />;
}

export default StepAI_Purpose;
